"use client";
import { ReactNode } from "react";
import "../globals.css";
import SiteChrome from "../components/SiteChrome";

interface LayoutProps {
  children: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  return <SiteChrome>{children}</SiteChrome>;
}
